import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ToastPlugin from 'vue-toast-notification'

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'

// Vue toast css
import 'vue-toast-notification/dist/theme-bootstrap.css'

// Global CSS
import './styles/global.css'

document.title = 'El Terreno - Carrera XHIDENXI 2026'

createApp(App)
  .use(router)
  .use(ToastPlugin)
  .mount('#app')
